import { Component, Inject, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppAnunciosService } from '../../../core/services/appAnunciosService.service';
import { AppAnuncios } from '../../../core/models/appAnuncios.model';

import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Editor, Toolbar } from 'ngx-editor';
import { LivesSessionHelper } from '../../../core/helper/livesSessionHelper';

@Component({
  selector: 'app-anuncios-edit-dialog',
  templateUrl: './anuncios-edit-dialog.component.html',
  styleUrls: ['./anuncios-edit-dialog.component.scss'],
  providers: [AppAnunciosService]
})
export class AnunciosEditDialog {

  panelIcon = 'newspaper'; // Material icon
  panelTitle = 'Crear anuncio';
  panelTitleTwo = 'Anuncio';
  panelDescription = 'Anuncios';

  @ViewChild('scrollableSection', { static: false }) scrollableSection: ElementRef;
  showScrollDown = true;

  announcement1: string;
  company: string[];
  title: string;
  content: string;
  createdAt: string;
  modifiedOn: string;
  publishedOn: string;
  publisher: string;
  status: string;
  data: AppAnuncios;

  form: FormGroup;
  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  constructor(
    public dialogRef: MatDialogRef<AnunciosEditDialog>,
    @Inject(MAT_DIALOG_DATA) public inputData: AppAnuncios,
    private appAnunciosService: AppAnunciosService,
    private _livesSession: LivesSessionHelper,
  ) {
    this.data = inputData;
    this.getPageData();
  }

  ngOnInit(): void {
    this.editor = new Editor({
      inputRules: true,
      keyboardShortcuts: true,
    });

    const formattedPublishedOn = this.data?.publishedOn ? this.formatDate(new Date(this.data.publishedOn)) : '';
    const formattedModifiedOn = this.data?.modifiedOn ? this.formatDate(new Date(this.data.modifiedOn)) : '';


    this.form = new FormGroup({
      company: new FormControl(this.company, Validators.required),
      title: new FormControl(this.data?.title, Validators.required),
      status: new FormControl({ value: this.data?.status, disabled: false }),
      publisher: new FormControl({ value: this.data?.publisher, disabled: false }),
      editorContent: new FormControl(this.content, Validators.required),
      publishedOn: new FormControl({ value: formattedPublishedOn, disabled: false }),
      modifiedOn: new FormControl({ value: formattedModifiedOn, disabled: false }),
    });


    setTimeout(() => {
      this.detectScroll();
    }, 0);

  }


  ngAfterViewInit() {
    this.scrollableSection.nativeElement.addEventListener('scroll', this.detectScroll.bind(this));
  }

  //activar y desactivar el botón de scroll hasta el final
  detectScroll(): void {
    const element = this.scrollableSection.nativeElement;

    // Posición actual del scroll
    const scrollPosition = element.scrollTop;

    // Altura del contenedor
    const clientHeight = element.clientHeight;

    // Altura total del contenido en el contenedor
    const scrollHeight = element.scrollHeight;

    // Comprobar si hay scroll o no
    if (scrollHeight === clientHeight) {
      this.showScrollDown = false;
    } else {
      this.showScrollDown = true;
    }

    // Comprobar si hemos llegado al final del contenedor
    if (scrollPosition + clientHeight >= scrollHeight) {
      this.showScrollDown = false;
    }
  }

  companySelectedChanged(selectedCompanyCode: any) {
    const currentCompanyValue = this.form.get('company').value;

    if (JSON.stringify(currentCompanyValue) !== JSON.stringify(selectedCompanyCode)) {
      this.form.get('company').setValue(selectedCompanyCode, { emitEvent: false });
    }
  }
  
  closePopUp() {
    this.dialogRef.close();
  }

  getCompaniesIds(companies: [{ name: string, company1: string }]): string[] {
    return companies ? companies.map(company => company.company1) : null
  }

  getPageData() {
    this.panelTitle = this.data?.isNew ? 'Crear anuncio' : 'Anuncio';

    this.announcement1 = this.data?.announcement1 || '';
    this.company = this.getCompaniesIds(this.data?.companies) || [''];
    this.title = this.data?.title || '';
    this.content = this.data?.content || '';

    this.createdAt = this.data?.createdAt || '';
    this.modifiedOn = this.data?.modifiedOn || '';
    this.publishedOn = this.data?.publishedOn || '';

    this.publisher = this.data?.publisher || '';
    this.status = this.data?.status || '';
  }


  async saveAndPublishData() {
    try {
      const announcementId = await this.saveData();
      this.publishData(announcementId);
    } catch (error) {
      console.error('Error en saveAndPublishData:', error);
    }
  }

  saveData(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (this.form.valid) {
        const formData = this.form.getRawValue();

        if (this.announcement1) {
          const sessionId = this._livesSession.AspNetUserId;
          const sendDataJson = {
            "companies": formData.company,
            "title": formData.title,
            "content": formData.editorContent,
            "publisher": sessionId
          };

          this.appAnunciosService.updateModel(this.announcement1, sendDataJson).subscribe(
            (response) => {
              this.closePopUp();
              resolve(response.announcement1); // Asume que la respuesta contiene el id
            },
            (error) => {
              console.error('Error al guardar el anuncio', error);
              reject(error);
            }
          );
        } else {
          const sendDataJson = {
            "companies": formData.company,
            "title": formData.title,
            "content": formData.editorContent
          };

          this.appAnunciosService.createModel(sendDataJson).subscribe(
            (response) => {
              this.closePopUp();
              resolve(response.announcement1); // Asume que la respuesta contiene el id
            },
            (error) => {
              console.error('Error al crear el anuncio', error);
              reject(error);
            }
          );
        }
      } else {
        console.error('Formulario no es válido');
        reject('Formulario no es válido');
      }
    });
  }


  publishData(id: string) {
    if (this.form.valid) {
      const formData = this.form.getRawValue();
      const sessionId = this._livesSession.AspNetUserId;
      const sendDataJson = {
        "companies": formData.company,
        "title": formData.title,
        "content": formData.editorContent,
        "published": true,
        "publisher": sessionId
      };

      this.appAnunciosService.updateModel(id, sendDataJson).subscribe(
        (response) => {
          this.closePopUp();
        },
        (error) => {
          console.error('Error al publicar el anuncio', error);
        }
      );
    } else {
      console.error('Formulario no es válido');
    }
  }


  ngOnDestroy() {
    this.scrollableSection.nativeElement.removeEventListener('scroll', this.detectScroll.bind(this));
    this.editor.destroy();

  }

  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('es-ES', options);
  }


}